// eslint-disable-next-line
import React, { Fragment } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { MdEmail } from 'react-icons/md';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { ArcaHttpClientEmail } from '../../../code/ArcaHttpClientEmail';
import { ArcaHttpSystem } from '../../../code/ArcaHttpSystem';
import { ArcaSecurity } from '../../../code/ArcaSecurity';
import { ArcaComponent } from '../../pages/ArcaComponent';
import { ArcaLink } from '../Fields/ArcaLink';
import { StatusBar } from '../StatusBar';
import { EmailEditPanel } from './EmailEditPanel';

export class EmailListPanel extends ArcaComponent {

    constructor(props) {
        super(props);

        this.state = {
            visibleEmail: null,
            isError: false,
            message: null,
            emails: null
        };
    }

    async componentDidMount() {
        this.GetEmails()
    }

    GetEmails() {
        ArcaHttpClientEmail.GetByPersonAsync(
            this.props.personId,
            ((emails) => this.setState({ emails })),
            (() => {
                this.setState({ isError: false, message: 'No emails found' })
            }),
            ((msg) => this.setState({
                isError: true,
                statusText: msg
            }))
        );
    }

    onEmailClicked(email) {

        this.setState({ visibleEmail: email })


        if (!email.BeenSeen) {
            ArcaHttpClientEmail.MarkAsSeen(email.Id,
                (() => {
                    this.GetEmails();
                    ArcaHttpSystem.Log(`Email marked as read`)
                    this.props.messageStatusRefresh()
                }),
                (() => ArcaHttpSystem.Log(`Email markup failed`))
            );
        }
    }

    onResend(email) {
        ArcaHttpClientEmail.Resend(
            email,
            (() => {
                this.setState(
                    {
                        isError: false,
                        message: 'The email has been resent',
                        visibleEmail: null,
                        emailEditorVisible: false
                    });
                    this.GetEmails()
            }),
            (() => this.setState({ isError: true, message: 'The email resend has failed' }))
        );
    }

    render() {

        let { visibleEmail, emailEditorVisible, isError, message, emails } = this.state;
        let onCancel = () => this.setState({ visibleEmail: null })

        return (
            <Fragment>
                <h1>Email Viewer</h1>
                <StatusBar message={message} isError={isError} />

                <div className='centerText'>
                    <ArcaLink text='Send message' onClick={() => this.setState({ emailEditorVisible: true })} />
                </div>

                {emailEditorVisible
                    ? <EmailEditPanel
                        onCancel={() => this.setState({ emailEditorVisible: false })}
                        personId={this.props.personId}
                        emailSent={() => this.GetEmails()}
                    />
                    : null}


                {emails ?
                    <table className='table table-striped' aria-labelledby="tabelLabel">
                        <thead>
                            <tr>
                                <th></th>
                                <th>Date</th>
                                <th>Subject</th>
                            </tr>
                        </thead>
                        <tbody>
                            {emails ? emails.map((email, k) =>
                                <tr key={k} >
                                    <td>{email.BeenSeen === 1 ? '' : '*' }</td>
                                    <td>
                                        <span
                                            className='minilink'
                                            onClick={() => this.onEmailClicked(email)}>
                                            <MdEmail />
                                            {email.DateSent.DateAndTimeShortPretty}
                                        </span>
                                    </td>
                                    <td>{email.Subject}</td>
                                </tr>
                            )
                                : null}
                        </tbody>
                    </table>
                    : null}

                {visibleEmail
                    ? <Modal isOpen={visibleEmail !== null} toggle={onCancel} >
                        <ModalHeader>
                            {ArcaSecurity.IsAdmin || ArcaSecurity.IsWalker
                                ? <ArcaLink text='Resend' onClick={this.onResend.bind(this, visibleEmail)} />
                                : null}

                            <ArcaLink text='Cancel' onClick={onCancel} />
                        </ModalHeader>
                        <ModalBody>
                            {ReactHtmlParser(visibleEmail.Subject)}
                            {ReactHtmlParser(visibleEmail.Body)}
                        </ModalBody>
                    </Modal>
                    : null}

            </Fragment>
        );
    }
}